import { buildNavigationUrl } from "../../../util/buildNavigationUrl";
const buildContactNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  if (status === "all") query.delete("status");
  else if (status) query.set("status", status);
  return buildNavigationUrl(`/contacts/${recordId}/${activeSubPage}`, query);
};

export { buildContactNavigationTargetUrl };
